import { useState, useEffect } from 'react';

export const useDebounce = (callback: (text: string) => void, delay: number, defaultValue: string = '') => {
  const [debounceTimeout, setDebounceTimeout] = useState<number | null>(null);
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const onChangeValue = (text: string) => {
    setValue(text);
    if (debounceTimeout) clearTimeout(debounceTimeout);

    const timeout = setTimeout(() => {
      callback(text);
    }, delay);

    setDebounceTimeout(timeout as unknown as number);
  };

  return {
    value,
    onChangeValue,
  };
};
